import React, { useEffect, useState } from 'react';

import { 
  CharacterSheetInterface,
} from "@dndModels";
import CommonUtilities from "@utilities/common_utilities";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import FlexBox from '@components/layout/FlexBox';
import SelectStringBox from '@components/input/selects/SelectStringBox';
import { CHARACTER_LEVELS } from '@dndModels/Constants';

interface Props {
  char: CharacterSheetInterface;
  disabled?: boolean;
  // onChange: () => void;
}

const common_util = CommonUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterInitCustomizations({ 
  char,
  disabled = false,
}: Props) {
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <FlexBox direction="row" className="padded">
      <FlexBox xs_expand={0} className="centered" style={{ width: "33%" }} direction="column">
        <FlexBox xs_expand={0} className="header">
          Override Initiative: 
        </FlexBox>
        <FlexBox xs_expand={0} className="small_label gray">
          Currently { char.initiative_modifier }
        </FlexBox>
      </FlexBox>
      <FlexBox>
        <SelectStringBox 
          name=""
          value={ char.customizations.overrides.init === undefined ? "Don't Override" : `${char.customizations.overrides.init}` } 
          options={["Don't Override",...CHARACTER_LEVELS]}
          disabled={ disabled }
          onChange={ async (changed: string) => {
            if (changed === "Don't Override") {
              delete char.customizations.overrides.init;
            } else {
              char.customizations.overrides.init = +changed;
            }
            setReloading(true);
            char.changed();
            char.subscription_holder.recalculate();
          }}
        />
      </FlexBox>
    </FlexBox>
  );
}
